export interface FontWeights {
  heavy: number
}

export const createFontWeights = (): FontWeights => ({
  heavy: 600,
})
